module.exports = __webpack_public_path__ + "img/82800.3f9ec214.jpg";